/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('schemaImporter', [
  '$timeout',

  function ($timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./schema-importer.html'),

      replace: true,

      controller: 'SchemaImporterController',

      scope: {
        component: '=',
        selectedFields: '=',
        hasError: '=?',
        valid: '=?',
      },

      link(scope, element, attrs) {
        const $splitter = element.find('.schema-importer-splitter');
        const $availableFields = element.find('.schema-importer-available-fields');
        const $selectedFields = element.find('.schema-importer-selected-fields');

        scope.setHeight = function () {
          $timeout(function () {
            const availableFieldsHeight = $availableFields.height();
            const selectedFieldsHeight = $selectedFields.height();
            const height = availableFieldsHeight > selectedFieldsHeight ? availableFieldsHeight : selectedFieldsHeight;
            $splitter.height(height);
          });
        };

        scope.setHeight();
      },
    };
  },
]);
